// @flow

import typeToReducer from 'type-to-reducer'

import type { Limits } from '@alphaott/api-client/types/limits'

import { GET_TVSHOW_LIMITS, RESET_TVSHOW_LIMITS } from '../../actions/tvshowLimits'

export type TVShowLimitState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Limits | {},
}

const initialState: TVShowLimitState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: null,
  data: {},
}

const tvshowLimits = typeToReducer(
  {
    [GET_TVSHOW_LIMITS]: {
      LOADING: (state): TVShowLimitState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): TVShowLimitState => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        data: action.payload.data,
      }),

      ERROR: (state, action): TVShowLimitState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
      }),
    },
    [RESET_TVSHOW_LIMITS]: () => initialState,
  },
  initialState,
)

export { tvshowLimits }
